import { PermissoesInterface } from "../ImportBackend/Interfaces/SistemaModuloPermissaoInterfaces"
import { SISTEMA_PERMISSOES } from "../ImportBackend/types/AcessosDataTypes"
import ClsAcesso from "../Utils/ClsAcesso"

export interface MenuOpcoesInterface {
  descricao: string
  path: string
  icon: string
  filhos: Array<MenuOpcoesInterface>
  modulo: string
  permissao: string
}

// TODO - Novo Menu / Modulo 
const MENU: Array<MenuOpcoesInterface> = [
  {
    descricao: 'Cadastros',
    path: '',
    icon: 'app_registration_outlined',
    modulo: '',
    permissao: '',
    filhos: [
      /*
      {
        descricao: 'Clientes',
        path: '/Clientes',
        icon: 'people',
        filhos: [],
        modulo: SISTEMA_PERMISSOES.CLIENTES.MODULO,
        permissao: SISTEMA_PERMISSOES.CLIENTES.PERMISSOES.MANUTENCAO
      },
      */
      {
        descricao: 'Veículos',
        path: '/Veiculos',
        icon: 'local_shipping',
        filhos: [],
        modulo: SISTEMA_PERMISSOES.VEICULOS.MODULO,
        permissao: SISTEMA_PERMISSOES.VEICULOS.PERMISSOES.MANUTENCAO
      }
    ]
  },
  /*
  {
    descricao: 'DRG',
    path: '',
    icon: 'app_registration_outlined',
    modulo: '',
    permissao: '',
    filhos: [
      {
        descricao: 'Cadastro de Correspondências',
        path: '/DRGCadastroCorrespondencia',
        icon: 'people',
        filhos: [],
        modulo: SISTEMA_PERMISSOES.DRG.MODULO,
        permissao: SISTEMA_PERMISSOES.DRG.PERMISSOES.CADASTRO_CORRESPONDENCIA
      },
      {
        descricao: 'Cadastro "De / Para" (ERP - DRG)',
        path: '/DRGClientesDePara',
        icon: 'people',
        filhos: [],
        modulo: SISTEMA_PERMISSOES.DRG.MODULO,
        permissao: SISTEMA_PERMISSOES.DRG.PERMISSOES.DADOS_CORRESPONDENCIA
      },
      {
        descricao: 'Enviar DRG Brasil',
        path: '/DRGEnvio',
        icon: 'people',
        filhos: [],
        modulo: SISTEMA_PERMISSOES.DRG.MODULO,
        permissao: SISTEMA_PERMISSOES.DRG.PERMISSOES.ENVIAR_DRG
      },
      {
        descricao: 'XML',
        path: '/DRGCadastroXML',
        icon: 'people',
        filhos: [],
        modulo: SISTEMA_PERMISSOES.DRG.MODULO,
        permissao: SISTEMA_PERMISSOES.DRG.PERMISSOES.CADASTRO_XML
      },
      {
        descricao: 'SQL',
        path: '/DRGCadastroSQL',
        icon: 'people',
        filhos: [],
        modulo: SISTEMA_PERMISSOES.DRG.MODULO,
        permissao: SISTEMA_PERMISSOES.DRG.PERMISSOES.CADASTRO_SQL
      }
    ]
  },
    {
    descricao: 'Fator RH',
    path: '',
    icon: 'app_registration_outlined',
    modulo: '',
    permissao: '',
    filhos: [
      {
        descricao: 'Cadastro de Correspondências',
        path: '/FatorRHCadastroCorrespondencia',
        icon: 'people',
        filhos: [],
        modulo: SISTEMA_PERMISSOES.FATORRH.MODULO,
        permissao: SISTEMA_PERMISSOES.FATORRH.PERMISSOES.CADASTRO_CORRESPONDENCIA
      },
      {
        descricao: 'Cadastro "De / Para" (ERP - Fator RH)',
        path: '/FatorRHClientesDePara',
        icon: 'people',
        filhos: [],
        modulo: SISTEMA_PERMISSOES.FATORRH.MODULO,
        permissao: SISTEMA_PERMISSOES.FATORRH.PERMISSOES.DADOS_CORRESPONDENCIA
      },
      {
        descricao: 'Enviar Fator RH Brasil',
        path: '/FatorRHEnvio',
        icon: 'people',
        filhos: [],
        modulo: SISTEMA_PERMISSOES.FATORRH.MODULO,
        permissao: SISTEMA_PERMISSOES.FATORRH.PERMISSOES.ENVIAR_FATORRH
      },
      {
        descricao: 'JSON',
        path: '/FatorRHCadastroJSON',
        icon: 'people',
        filhos: [],
        modulo: SISTEMA_PERMISSOES.FATORRH.MODULO,
        permissao: SISTEMA_PERMISSOES.FATORRH.PERMISSOES.CADASTRO_JSON
      },
      {
        descricao: 'SQL',
        path: '/FatorRHCadastroSQL',
        icon: 'people',
        filhos: [],
        modulo: SISTEMA_PERMISSOES.FATORRH.MODULO,
        permissao: SISTEMA_PERMISSOES.FATORRH.PERMISSOES.CADASTRO_SQL
      }
    ]
  },
  */
  {
    descricao: 'Relatórios',
    path: '',
    icon: 'assessment',
    modulo: '',
    permissao: '',
    filhos: [
      {
        descricao: 'Histórico de Localização',
        path: '/HistoricoLocalizacao',
        icon: 'location_on',
        filhos: [],
        modulo: SISTEMA_PERMISSOES.RELATORIOS.MODULO,
        permissao: SISTEMA_PERMISSOES.RELATORIOS.PERMISSOES.HISTORICO_LOCALIZACAO
      }
    ]
  },
  {
    descricao: 'Sistema',
    path: '',
    icon: 'app_registration_outlined',
    modulo: '',
    permissao: '',
    filhos: [
      /*
      {
        descricao: 'Parâmetros',
        path: '/Parametros',
        icon: 'people_alt_outlined',
        filhos: [],
        modulo: SISTEMA_PERMISSOES.PARAMETRO.MODULO,
        permissao: SISTEMA_PERMISSOES.PARAMETRO.PERMISSOES.MANUTENCAO
      },
      */
      {
        descricao: 'Grupos de Usuários',
        path: '/Grupos',
        icon: 'people_alt_outlined',
        filhos: [],
        modulo: SISTEMA_PERMISSOES.GRUPOS.MODULO,
        permissao: SISTEMA_PERMISSOES.GRUPOS.PERMISSOES.MANUTENCAO
      },
      {
        descricao: 'Usuários',
        path: '/Usuarios',
        icon: 'person_outline_outlined',
        filhos: [],
        modulo: SISTEMA_PERMISSOES.USUARIOS.MODULO,
        permissao: SISTEMA_PERMISSOES.USUARIOS.PERMISSOES.CADASTRO_USUARIO_CLIENTE
      }
    ]
  }
]

export default class ClsMenu {

  private retornoMenu: Array<MenuOpcoesInterface> = []

  public constructor( private Permissoes: Array<PermissoesInterface> = [] ) {
    this.retornoMenu = this.limparMenuSemFilhos( this.tratarPermissoes( MENU ) )
  }

  private limparMenuSemFilhos ( menu: Array<MenuOpcoesInterface> ): Array<MenuOpcoesInterface> {
    let retorno: Array<MenuOpcoesInterface> = []

    menu.forEach( ( v ) => {
      if (
        ( v.modulo
          && v.modulo.length > 0
          && v.permissao
          && v.permissao.length > 0 )
        || ( v.modulo
          && v.modulo.length > 0 )
        || ( !v.modulo && !v.permissao )
      ) {
        if ( v.filhos && v.filhos.length > 0 ) {
          v.filhos = this.limparMenuSemFilhos( v.filhos )
        }

        if ( ( v.filhos && v.filhos.length > 0 )
          || v.path.length > 0
        )
          retorno.push( v )
      }
    } )

    return retorno


  }
  private tratarPermissoes ( menu: Array<MenuOpcoesInterface> ): Array<MenuOpcoesInterface> {

    let retorno: Array<MenuOpcoesInterface> = []
    let clsAcesso = new ClsAcesso()

    menu.forEach( ( v ) => {
      if (
        ( v.modulo
          && v.modulo.length > 0
          && v.permissao
          && v.permissao.length > 0
          && clsAcesso.chkAcesso( this.Permissoes, v.modulo, v.permissao ) )
        || ( v.modulo
          && v.modulo.length > 0
          && v.permissao.length === 0
          && clsAcesso.chkAcessoModulo( this.Permissoes, v.modulo ) )
        || ( !v.modulo && !v.permissao )
      ) {
        if ( v.filhos && v.filhos.length > 0 ) {
          v.filhos = this.tratarPermissoes( v.filhos )
        }
        retorno.push( v )
      }
    } )

    return retorno

  }

  public get MenuOpcoes (): Array<MenuOpcoesInterface> {
    return this.retornoMenu
  }

}